import { useQuery, UseQueryOptions } from "react-query";
import { getResources } from "../services/resources.service";
import { IResources } from "../interfaces/resources.interface";
import { IRequest } from "../interfaces/authentication.interface";

export function useResources<T extends any = IRequest<IResources>>(
    locale: string,
    countryIsoCode?: string,
    options?: UseQueryOptions<any, unknown, T>
) {
    return useQuery({
        queryKey: ["resources", locale, countryIsoCode],
        queryFn: () => getResources(locale, countryIsoCode),
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        ...options
    });
}
